var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"create"},[_c('society-form',{attrs:{"save-loading":_vm.saveLoading},on:{"form-submit":_vm.save,"cancel":_vm.cancel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }